import "./styleLogin.css";
import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";

import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";

const Login = () => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user, login: authLogin } = useAuth();

  console.log("user = ", user);

  const navigate = useNavigate();

  // Redireciona se já estiver logado
  useEffect(() => {
    if (user) {
      navigate("/painel");
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        "https://sapl.cantarellisolucoes.com.br/wp-json/custom/v1/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: login,
            password: password,
          }),
        },
      );

      const data = await response.json();

      console.log("Login = ", data.data);

      if (!response.ok) {
        throw new Error(data.message || "Erro ao fazer login");
      }

      if (data.success) {
        const userData = {
          token: data.token,
          id: data.user.id,
          username: data.user.username,
          nome: data.user.nome,
          email: data.user.email,
          tipo: data.user.tipo,
          modulos: data.user.modulos,
          roles: data.user.roles || ["user"],
        };

        authLogin(userData);
        navigate("/painel");
      } else {
        alert(data.message || "Usuário ou senha inválidos");
      }
    } catch (error) {
      console.error("Erro ao fazer login:", error);
      alert(error.message || "Erro ao fazer login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center", // Centraliza tudo
        backgroundColor: "#f5f5f5", // Cor de fundo neutra
      }}
    >
      {/* Container principal */}
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "2.5rem",
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        }}
      >
        {/* Título em vez de logo */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "2.5rem",
          }}
        >
          <h1
            style={{
              color: "#3b82f6",
              fontSize: "2rem",
              marginBottom: "0.5rem",
              fontWeight: 600,
            }}
          >
            Sistema Legislativo
          </h1>
          <p style={{ color: "#6b7280", fontSize: "1rem", marginTop: 0 }}>
            Faça login para acessar o sistema
          </p>
        </div>

        {/* Formulário */}
        <form onSubmit={handleLogin}>
          {/* Login */}
          <div style={{ marginBottom: "1.5rem" }}>
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                color: "#374151",
                fontWeight: "500",
                fontSize: "0.95rem",
              }}
            >
              Usuário
            </label>

            <InputText
              type="text"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              style={{
                width: "100%",
                padding: "0.8rem",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                fontSize: "1rem",
                boxSizing: "border-box",
                transition: "border-color 0.2s",
              }}
              placeholder="Digite seu usuário"
              autoComplete="username"
              onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
              onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
            />
          </div>

          {/* Senha */}
          <div style={{ marginBottom: "2rem" }}>
            <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                color: "#374151",
                fontWeight: "500",
                fontSize: "0.95rem",
              }}
            >
              Senha
            </label>

            <div style={{ position: "relative" }}>
              <InputText
                type={showPassword ? "text" : "password"}
                placeholder="Digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: "100%",
                  paddingRight: "40px",
                  padding: "0.8rem",
                  borderRadius: "8px",
                  border: "1px solid #d1d5db",
                  fontSize: "1rem",
                  boxSizing: "border-box",
                  transition: "border-color 0.2s",
                }}
                autoComplete="current-password"
                onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
                onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
              />
              <i
                className={`pi ${showPassword ? "pi-eye-slash" : "pi-eye"}`}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#6b7280",
                  fontSize: "1rem",
                }}
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
          </div>

          {/* Botão */}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "0.9rem",
              backgroundColor: loading ? "#9ca3af" : "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: loading ? "not-allowed" : "pointer",
              marginBottom: "1.5rem",
              transition: "background-color 0.2s, transform 0.1s",
            }}
            onMouseOver={(e) =>
              !loading && (e.target.style.backgroundColor = "#2563eb")
            }
            onMouseOut={(e) =>
              !loading && (e.target.style.backgroundColor = "#3b82f6")
            }
            onMouseDown={(e) =>
              !loading && (e.target.style.transform = "scale(0.98)")
            }
            onMouseUp={(e) =>
              !loading && (e.target.style.transform = "scale(1)")
            }
          >
            {loading ? (
              <span>
                <i
                  className="pi pi-spinner pi-spin"
                  style={{ marginRight: "8px" }}
                ></i>
                Entrando...
              </span>
            ) : (
              "Entrar"
            )}
          </button>

          {/* Link para esquecer senha (opcional) */}
          <div style={{ textAlign: "center" }}>
            <a
              href="#"
              style={{
                color: "#6b7280",
                textDecoration: "none",
                fontSize: "0.9rem",
                transition: "color 0.2s",
              }}
              onMouseOver={(e) => (e.target.style.color = "#3b82f6")}
              onMouseOut={(e) => (e.target.style.color = "#6b7280")}
            >
              Esqueceu sua senha?
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
